import {
  Box,
  Button,
  Grid,
  TextField,
  Modal,
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
} from "@mui/material";
import React, { useState } from "react";
import "./Fpm.css";
import img1 from "../images/fmpAssets/flipCardsImg/banks_front.png";
import img2 from "../images/fmpAssets/flipCardsImg/cooperatives_front.png";
import img3 from "../images/fmpAssets/flipCardsImg/microfinance-non-governmental-organizations_front.png";
import img4 from "../images/fmpAssets/flipCardsImg/lending-and-finance-companies_front.png";
import img5 from "../images/fmpAssets/flipCardsImg/insurance-companies.png";
import img6 from "../images/fmpAssets/flipCardsImg/digital-financial-service-providers_front.png";
import img7 from "../images/fmpAssets/flipCardsImg/mutual-benefit-associations.png";
import { useDispatch } from "react-redux";
import { setFpmQuestion1 } from "../features/fpmSlice/FmpSlice";
import { useNavigate } from "react-router-dom";
import { CloseRounded } from "@mui/icons-material";
import Logo from "../images/logo_quick-learning-tool.png";
import Swal from "sweetalert2";

function FpmPage() {
  const [question1, setQuestion1] = useState();
  const [modalText, setModalText] = useState();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const [openFSP, setOpenFSP] = useState(false);
  const handleCloseFSP = () => setOpenFSP(false);

  const handleOpenFSP = (type) => {
    setOpenFSP(true);

    if (type === "Bank") {
      setModalText(
        "Banks are supervised by the Bangko Sentral ng Pilipinas (BSP) and authorized to deliver savings/deposits, loan products, insurance, investments, and remittances, among others, to the public"
      );
    } else if (type === "Coop") {
      setModalText(
        "Cooperatives are supervised by the Cooperative Development Authority (CDA)and authorized to deliver savings and loan products only to their members."
      );
    } else if (type === "Micro") {
      setModalText(
        "Microfinance NGOs are supervised by the Microfinance NGO Regulatory Council (MNRC) headed by the Securities and Exchange Commission (SEC) and authorized to deliver loans, complemented with savings mobilization or capital build-up of not more than 50% of loan amount, with low-income individuals as target customers."
      );
    } else if (type === "Lend") {
      setModalText(
        "Lending and Finance Companies are supervised by the Securities and Exchange Commission (SEC) with the primary activity of extending loans to the public.  As stock corporations, it shall lend from its own capital funds or from funds obtained from not more than 19 persons."
      );
    } else if (type === "Insur") {
      setModalText(
        "Insurance Companies offer insurance products from payment of premiums, which is supervised by the Insurance Commission."
      );
    } else if (type === "Mutual") {
      setModalText(
        "Mutual Benefit Associations provide insurance and other benefits to its members by paying a membership fee, which is supervised by the Insurance Commission."
      );
    } else if (type === "DSP") {
      setModalText(
        "Digital FSPs are differentiated with other FSPs by their use of mainly financial technologies to deliver their products and services. The digital platforms they use offer online access to savings, loans, and insurance. With a combined use of technology, big data, and proprietary decision models, it can offer customers with a range of financial options that work best with their lifestyle."
      );
    }
  };

  const handleContinue = () => {
    if (question1) {
      handleOpen();
    } else {
      Swal.fire({
        icon: "error",
        title: "Incomplete Fields",
        text: "Please complete all required fields to proceed",
        customClass: {
          popup: "custom-swal-popup",
          confirmButton: "custom-swal-button",
        },
      });
    }
  };

  const handleNext = () => {
    dispatch(setFpmQuestion1(question1));
    navigate("/page2/En");
  };

  return (
    <Box className="Main__Card__FPM">
      <Grid container>
        <Grid Item xs={12} md={3} className="left-card">
          <Box className="new-logo-container">
            <img src={Logo} alt="logo" className="new-logo-img" />
          </Box>
          <Box sx={{ marginBottom: "1rem" }}>
            <Button className="fpm--button" onClick={() => navigate("/Fil")}>
              To Filipino Ver.
            </Button>
          </Box>
          <Box className="instruction-card">
            <p className="instruction-title">Activity Instructions</p>
            <p className="instruction-text">
              Choose a Suitable Financial Product and Service Provider.
            </p>
            <p className="instruction-text">
              An empowered customer knows what product features are suited to
              his/her needs and conditions and can compare product features
              among 2-4 Financial Service Providers (FSPs) actively operating in
              the area.
            </p>
            <p className="instruction-text">
              In this section, exercises are provided to refresh the customer
              about different types of FSPs and the product features to consider
              per selected financial product. A tool called Financial Product
              Matrix (FPM) is made available to help organize product
              information that will facilitate comparison and ranking between
              FSPs based on the customer’s specific preferences.
            </p>
          </Box>
        </Grid>
        <Grid Item xs={12} md={9} className="right-card">
          <Box className="fpm__card">
            <Box className="fpm__container">
              <Box className="fpm--opening--text1">
                <p>Get to Know Financial Service Providers (FSP)</p>
              </Box>
              <Grid container>
                <Grid item xs={12} md={6} className="child-left-card">
                  <Box sx={{ marginBottom: "1rem" }}>
                    <h4>Types of FSPs</h4>
                    <p>Click on the box to read more information.</p>
                  </Box>
                  <Box className="card-container">
                    <Box className="flip-card-containers">
                      <img
                        src={img1}
                        alt=""
                        className="flippable--card--image"
                        onClick={() => handleOpenFSP("Bank")}
                      />
                    </Box>
                    <Box className="flip-card-containers">
                      <img
                        src={img2}
                        alt=""
                        className="flippable--card--image"
                        onClick={() => handleOpenFSP("Coop")}
                      />
                    </Box>
                    <Box className="flip-card-containers">
                      <img
                        src={img3}
                        alt=""
                        className="flippable--card--image"
                        onClick={() => handleOpenFSP("Micro")}
                      />
                    </Box>
                  </Box>
                  <Box className="card-container" sx={{ marginTop: "1rem" }}>
                    <Box className="flip-card-containers">
                      <img
                        src={img4}
                        alt=""
                        className="flippable--card--image"
                        onClick={() => handleOpenFSP("Lend")}
                      />
                    </Box>
                    <Box className="flip-card-containers">
                      <img
                        src={img5}
                        alt=""
                        className="flippable--card--image"
                        onClick={() => handleOpenFSP("Insur")}
                      />
                    </Box>
                    <Box className="flip-card-containers">
                      <img
                        src={img7}
                        alt=""
                        className="flippable--card--image"
                        onClick={() => handleOpenFSP("Mutual")}
                      />
                    </Box>
                  </Box>
                  <Box
                    sx={{
                      marginTop: "1rem",
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    <Box sx={{ width: "30%" }}>
                      <img
                        src={img6}
                        alt=""
                        className="flippable--card--image"
                        onClick={() => handleOpenFSP("DSP")}
                      />
                    </Box>
                  </Box>
                </Grid>
                <Grid item xs={12} md={6} className="child-right-card">
                  <Box className="fpm--question--text">
                    <p>
                      Based on your financial goal and plan, what type of FSP do
                      you think can provide you with your needed financial
                      product?
                    </p>
                  </Box>

                  <Box className="fpm--radio--group--container">
                    <FormControl>
                      <RadioGroup className="fpm--radio--group">
                        <FormControlLabel
                          className="fpm--radio--button"
                          value="Banks"
                          control={
                            <Radio
                              onChange={(e) => setQuestion1(e.target.value)}
                            />
                          }
                          label="Banks"
                        />
                        <FormControlLabel
                          className="fpm--radio--button"
                          value="Cooperatives"
                          control={
                            <Radio
                              onChange={(e) => setQuestion1(e.target.value)}
                            />
                          }
                          label="Cooperatives"
                        />
                        <FormControlLabel
                          className="fpm--radio--button"
                          value="Insurance Companies"
                          control={
                            <Radio
                              onChange={(e) => setQuestion1(e.target.value)}
                            />
                          }
                          label="Insurance Companies"
                        />
                        <FormControlLabel
                          className="fpm--radio--button"
                          value="Lending & Finance Companies"
                          control={
                            <Radio
                              onChange={(e) => setQuestion1(e.target.value)}
                            />
                          }
                          label="Lending & Finance Companies"
                        />

                        <FormControlLabel
                          className="fpm--radio--button"
                          value="Mutual Benefit Associations"
                          control={
                            <Radio
                              onChange={(e) => setQuestion1(e.target.value)}
                            />
                          }
                          label="Mutual Benefit Associations"
                        />
                        <FormControlLabel
                          className="fpm--radio--button"
                          value="Digital Financial Service Providers"
                          control={
                            <Radio
                              onChange={(e) => setQuestion1(e.target.value)}
                            />
                          }
                          label="Digital Financial Service Providers"
                        />
                        <FormControlLabel
                          className="fpm--radio--button"
                          value="Microfinance Non-Governmental Organizations"
                          control={
                            <Radio
                              onChange={(e) => setQuestion1(e.target.value)}
                            />
                          }
                          label="Microfinance Non-Governmental Organizations"
                        />
                      </RadioGroup>
                    </FormControl>
                    <Box className="fpm__button__container">
                      <Button
                        className="fpm--button"
                        onClick={() => handleContinue()}
                      >
                        Next
                      </Button>
                    </Box>
                  </Box>
                </Grid>
              </Grid>
            </Box>
          </Box>
        </Grid>
      </Grid>

      <Modal open={open} onClose={handleClose}>
        <Box className="fpm__modal">
          <Box className="fpm--ending--text">
            <p
              style={{
                fontSize: "1.7rem",
                fontWeight: "700",
                marginBottom: "2rem",
              }}
            >
              Wait up!
            </p>
            <p>
              Do not make a decision yet. <br />
              <br />
              An empowered customer will gather information first, usually from
              more than one FSP, make comparisons about which FSP offers the
              most suitable product features, and then take an informed
              decision. <br />
              <br />
              Click on Next button to continue.
            </p>

            <Button className="fpm--button--modal" onClick={() => handleNext()}>
              Next
            </Button>
          </Box>
        </Box>
      </Modal>

      <Modal open={openFSP} onClose={handleCloseFSP}>
        <Box className="fpm__modal">
          <Box className="fpm--modal--text">
            <CloseRounded
              className="fpm--modal--iconButton"
              onClick={handleCloseFSP}
            />
            <p>{modalText}</p>
          </Box>
        </Box>
      </Modal>
    </Box>
  );
}

export default FpmPage;
